/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './PictureUploadButton.style';
import messages from 'src/shared/app/account/profile/l10n/pictureUploadL10n';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';

type Props = {
  layoutClass?: string,
  label?: string,
  isDisabled?: boolean,
  handleChange: (file: File) => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const PictureUploadButton = ({
  layoutClass,
  label,
  isDisabled,
  handleChange,
  intl,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onClick = () => {
    const { current: inputElt } = inputRef;

    if (inputElt instanceof HTMLElement) {
      inputElt.click();
    }
  };

  const onInputChange = ({ target }: Event) => {
    const { current: inputElt } = inputRef;

    if (target instanceof HTMLInputElement) {
      const files = target.files || [];
      const file = files.length ? files[0] : null;

      if (file) {
        handleChange(file);
      }

      if (inputElt instanceof HTMLInputElement) {
        inputElt.value = null;
      }
    }
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Refs
   |----------------------------------------------------------------------------
   */

  const inputRef = React.createRef();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <React.Fragment>
      <SecondaryButton
        layoutClass={layoutClass}
        isDisabled={isDisabled}
        handleClick={onClick}
      >
        {label || intl.formatMessage(messages.update)}
      </SecondaryButton>
      <input
        accept="image/jpg, image/png, image/gif, image/jpeg"
        className={classes.input}
        onChange={onInputChange}
        ref={
          // $FlowIssue
          inputRef
        }
        type="file"
      />
    </React.Fragment>
  );
};

export default compose(React.memo, injectIntl)(PictureUploadButton);
